import usePrivateAxios from "@/common/api/usePrivateAxios";
import { EstablishmentCompanyData, EstablishmentCompanyRespose } from "@/common/types/establishment/company.type";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const useEstablishmentCompany: (id?: string , enabled?: boolean) => UseQueryResult<EstablishmentCompanyData, unknown> = (id, enabled = true) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentCompanyRespose, unknown, EstablishmentCompanyData>({
    queryKey: ["establishmentCompany", id],
    queryFn: () => privateAxios.get(`/establishment/companies/${id}`),
    enabled,
    select: (data) => data?.data?.data,
  });
};

export default useEstablishmentCompany;
